import { dashboardConstants } from "./types";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case dashboardConstants.DEBTSITUATION:
      return {
        ...state,
        ...action.payload,
      };
    case dashboardConstants.ANNOUNCEMENTS:
      return {
        ...state,
        ...action.payload,
      };
    case dashboardConstants.ANNOUNCEMENT_DETAIL_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    case dashboardConstants.ANNOUNCEMENT_DETAIL_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case dashboardConstants.DASHBOARD_INFO_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    case dashboardConstants.DASHBOARD_INFO_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case dashboardConstants.IS_SHOW_MEMBER_APPLICATION:
      return {
        ...state,
        ...action.payload,
      };
    case dashboardConstants.DASHBOARD_ERROR:
      return {
        ...state,
      };
    case dashboardConstants.SET_CANDIDATE_CUSTOMER_STATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
